const dev = {
  API_ENDPOINT_URL: "https://api.pokemoke.net/api",
  MEDIA_ENDPOINT_URL: "https://api.pokemoke.net",
};

const prod = {
  API_ENDPOINT_URL: "https://api.pokemoke.net/api",
  MEDIA_ENDPOINT_URL: "https://api.pokemoke.net",
};

const test = {
  API_ENDPOINT_URL: "https://api.pokemoke.net/api",
  MEDIA_ENDPOINT_URL: "https://api.pokemoke.net",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
